import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import Loader from "../../../common/Loader";

import TripEventsApi from "../../../../services/resources/TripEventsApi";
import { ApiCallErrorMessageHandler } from "../../../../lib/coc-common-scripts";
import { formatFullName, pluralizeText } from "../../../../lib";
import axios from "axios";

function StudentsMoveToPendingModal(props) {
  const { close, getStudentsSelection, onUpdate } = props;

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [students, setStudents] = useState([]);

  const apiSignalRef = useRef(axios.CancelToken.source());

  useEffect(() => {
    const _apiSignal = apiSignalRef.current;
    return () => _apiSignal.cancel();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const students = await getStudentsSelection();

      if (students) {
        setStudents(students);
      } else {
        setErrorMessage("Failed to retrieve selected students");
      }

      setLoading(false);
    })();
  }, [getStudentsSelection]);

  const onSubmit = useCallback(async () => {
    setSubmitting(true);
    setErrorMessage("");

    try {
      await TripEventsApi.moveWaitlistedRegistrationsToPending(
        apiSignalRef.current.token,
        students.map((s) => s.id),
      );

      onUpdate();
      close();
    } catch (err) {
      setSubmitting(false);
      setErrorMessage(
        ApiCallErrorMessageHandler(err, "Failed to move students to pending"),
      );
    }
  }, [close, onUpdate, students]);

  return (
    <Modal isOpen={true} className="modal-container">
      <div className="card small-modal trip-modal">
        <p className="large-text mb-8">Move to pending</p>
        {loading ? (
          <Loader />
        ) : students.length > 0 ? (
          <>
            <p className="accent-text-dark mb-16">
              Are you sure you want to move {students.length} selected{" "}
              {pluralizeText("student", students.length)} from the waitlist to
              pending?
            </p>
            <div
              className="mb-24"
              style={{ maxHeight: "400px", overflow: "auto" }}
            >
              {students.map((s) => (
                <p className="fw-500 mb-4" key={s.id}>
                  {formatFullName(s.studentFirstName, s.studentLastName)}
                </p>
              ))}
            </div>
            <div className="modal-btns">
              <button
                className="link-text uppercase-text"
                disabled={submitting}
                onClick={close}
              >
                Cancel
              </button>
              <button
                className={`link-text uppercase-text ml-24${
                  submitting ? " disabled" : ""
                }`}
                disabled={submitting}
                onClick={onSubmit}
              >
                {submitting ? "Moving..." : "Move to Pending"}
              </button>
            </div>
            {!submitting && errorMessage && (
              <div
                className="text-right error-text mt-4"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {errorMessage}
              </div>
            )}
          </>
        ) : (
          errorMessage && <div className="error-text mt-4">{errorMessage}</div>
        )}
      </div>
    </Modal>
  );
}

export default React.memo(StudentsMoveToPendingModal);
